let index = 0;

/**
 * Given SVG markup, search for ID references like `url(#some_id)` and adds a unique suffix to all instances of the ID.
 * @param raw SVG markup
 */
export default function makeSvgIdsUnique(raw: string) {
  let o = raw;

  const suffix = '--ucts_uid_' + index++;

  // replace url(#a) with url(#a--ucts_uid_1)
  const urlRefs = raw.match(/url\(#([^)]+)\)/g) || [];

  for (const ref of urlRefs) {
    const oldId = ref.slice(5, -1);

    const newId = /_ucts_uid_\d+/.test(oldId)
      ? oldId.replace(/_ucts_uid_\d+/g, suffix)
      : oldId + suffix;

    o = o.replaceAll(`id="${oldId}"`, `id="${newId}"`);
    o = o.replaceAll(`(#${oldId})`, `(#${newId})`);
  }

  // replace xlink:href="#a" with xlink:href="#a--ucts_uid_1"
  const xlinkRefs = raw.match(/xlink:href="#([^"]+)"/g) || [];

  for (const ref of xlinkRefs) {
    const oldId = ref.slice(13, -1);

    const newId = /_ucts_uid_\d+/.test(oldId)
      ? oldId.replace(/_ucts_uid_\d+/g, suffix)
      : oldId + suffix;

    o = o.replaceAll(`id="${oldId}"`, `id="${newId}"`);
    o = o.replaceAll(`"#${oldId}"`, `"#${newId}"`);
  }

  // replace href="#a" with href="#a--ucts_uid_1". xlink:href is depricated
  const plainHrefs = raw.match(/href="#([^"]+)"/g) || [];

  for (const ref of plainHrefs) {
    const oldId = ref.slice(7, -1);

    const newId = /_ucts_uid_\d+/.test(oldId)
      ? oldId.replace(/_ucts_uid_\d+/g, suffix)
      : oldId + suffix;

    o = o.replaceAll(`id="${oldId}"`, `id="${newId}"`);
    o = o.replaceAll(`href="#${oldId}"`, `href="#${newId}"`);
  }

  return o;
}
